import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminLoginForm from '../components/forms/SuperAdminLoginForm';
import { useSuperAdminAuth } from '../hooks/useSuperAdminAuth';
import { ROUTES } from '../constants';
import './Login.css';

const SuperAdminLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { superAdminLogin } = useSuperAdminAuth();
  const navigate = useNavigate();

  const handleLogin = async (credentials) => {
    setIsLoading(true);

    try {
      await superAdminLogin(credentials);
      navigate(ROUTES.SUPER_ADMIN_DASHBOARD);
    } catch (err) {
      console.error('Super admin login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page" role="main" aria-label="Super admin login page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <img 
              src="/sks-icons.svg"
              alt="SKS Pvt Company Logo"
              className="login-logo-img"
              width="80"
              height="80"
            />
          </div>
          <h1>Platform Administrator</h1>
          <p>Sign in to manage tenants</p>
        </div>
        
        <SuperAdminLoginForm
          onSubmit={handleLogin}
          isLoading={isLoading}
        />
        
      </div>
    </div>
  );
};

export default SuperAdminLogin;

